import { type Curve, type Vector3 } from 'three'

export const SPLINES_COUNT = 5
export const SPLINE_WIDTH = 0.6
export const SPLINE_HEIGHT = 0.08

export interface SplinePose {
  position: Vector3
  rotationY: number
}

export function sampleSplines(curve: Curve<Vector3>, count: number): SplinePose[] {
  const splines: SplinePose[] = []

  for (let i = 0; i < count; i++) {
    const t = count > 1 ? i / (count - 1) : 0.5
    const point = curve.getPointAt(t)
    const tangent = curve.getTangentAt(t)
    splines.push({ position: point, rotationY: Math.atan2(tangent.x, tangent.z) })
  }

  return splines
}
